module.exports = __webpack_public_path__ + "img/logo.e0c7318c.svg";